/**
 * Useful functions for mapping between our field models (e.g. models/Participant.js) and structures
 * used by Vuelidate for validation. These functions allow you to select which fields from a given
 * field model are to be displayed and validated on a given form.
 *
 * These functions are used mainly in DataForm.vue.
 */

import * as _ from 'lodash'

export default {

    /**
     * Builds the form data model for Vuelidate, based on the selected field names from the given field model.
     */
    buildFormModel (fieldModel, fieldNames) {
        const form = {}
        _.each(fieldNames, (fn) => {
            form[fn] = null
        })
        return form
    },

    /**
     * Populates the form data model for Vuelidate, using field values from the given model instance.
     */
    populateFormModel (form, fieldModel, modelInstance, fieldNames) {
        _.each(fieldNames, (fn) => {
            if (fieldModel.fields[fn]) {
                if (fieldModel.fields[fn].type == 'checks') {
                    // for a checkbox group, convert a SET db value (e.g. "PRIMARY, SPECIALIST")
                    // to array for binding to control
                    if (modelInstance[fn] && modelInstance[fn].length) {
                        form[fn] = modelInstance[fn].split(',')
                    } else {
                        form[fn] = []
                    }
                } else {
                    form[fn] = modelInstance[fn]
                }
            }
        })
    },

    /**
     * Copies the Vuelidate form model values back to the given model instance.
     */
    extractFormModel (form, fieldModel, modelInstance, fieldNames) {
        _.each(fieldNames, (fn) => {
            if (fieldModel.fields[fn].type == 'checks') {
                // for a checkbox group, convert an array of selected items back to
                // a SET db value (e.g. "PRIMARY, SPECIALIST")
                if (form[fn].$model) {
                    modelInstance[fn] = form[fn].$model.join(',')
                }
            } else {
                modelInstance[fn] = form[fn].$model
            }
        })
    },

    /**
     * Populates the form validation stucture for Vuelidate, using validations for the selected field names
     * defined in the given field model (e.g. Participant).
     */
    buildFormValidations (fieldModel, fieldNames) {
        const vs = {}
        _.each(fieldNames, (fn) => {
            const field = fieldModel.fields[fn]
            if (field) {
                if (field.validations) {
                    vs[fn] = field.validations
                } else {
                    vs[fn] = {}
                }
            } else {
                new Error('ouch')
            }
        })

        return { form: vs }
    },

}
